import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement("g", { clipPath: "url(#moon_svg__clip0)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.81 16.33c.389.008.602.442.397.768a9.97 9.97 0 01-.845 1.173l-.033.04a9.884 9.884 0 01-2.126 1.883c-5.058 3.32-12.023 1.455-14.616-4.282C1.946 12.3 2.66 7.955 5.362 5.056a9.908 9.908 0 015.895-3.102c.38-.059.693.31.555.664a9.971 9.971 0 00-.432 1.328l-.004.013a9.935 9.935 0 001.34 7.874 9.935 9.935 0 006.696 4.362l.013.003c.14.022.278.043.418.06l.036.004c.309.037.62.059.932.067zM9.207 4.649c-.857.415-1.664.999-2.376 1.767L5.362 5.057l1.463 1.364C4.673 8.73 4.102 12.21 5.408 15.084l.001.004a7.999 7.999 0 0012.505 2.826 11.92 11.92 0 01-6.87-4.983 11.92 11.92 0 01-1.838-8.282z",
      fill: "#2d6ded"
    }
  )),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "moon_svg__clip0" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" })))
), a = t;
export {
  a as default
};
